// Protocol constants for the OCR ws-server frames.
//
// The production server emits raw WebSocket frames (NOT socket.io — see
// project memory + ocrSocket.ts header comment) with this JSON shape:
//
//   { table_name, action, process_id, execution_id?, type?, message?,
//     id_details: { user_id?, ...row fields } }
//
// See `OcrTrackingFrame` in ../types/documents.ts for the full type.

/** Backend table identifiers that appear on tracking frames. */
export const TABLES = {
  DOC_EXTRACTION_TRACKING: "doc_extraction_tracking",
  CONFIG_STUDIO_TRACKING: "config_studio_tracking",
  RECONCILIATION_TRACKING: "reconciliation_tracking",
} as const;

/** Action verbs the server attaches to frames. Mirrors OcrTrackingAction. */
export const ACTIONS = {
  INSERT: "insert",
  UPDATE: "update",
  PROCESS_COMPLETE: "process_complete",
} as const;

/** Frame `type` values used when `action` alone isn't specific enough. */
export const FRAME_TYPES = {
  FIELD_ITEM: "field_item",
  LINE_ITEM: "line_item",
} as const;
